<template>
  <div>
    <md-dialog :md-active.sync="open">
      <md-dialog-title>{{ message || defaultMessage }}</md-dialog-title>
      
      <md-dialog-actions>
        <md-button style="background: lightgrey; margin-right: 15px;" @click="open = false">
          Cancelar
        </md-button>
        <login/>
      </md-dialog-actions>
    </md-dialog>

    <slot :showAlert="showAlert"></slot>
  </div>
</template>

<script>
import login from "@/components/toolbar/signin";

export default {
  props: ["message"],
  components: {
    login
  },
  data() {
    return {
      open: false,
      defaultMessage: "Entre no site para continuar!"
    };
  },
  methods: {
    showAlert() {
      this.open = true;
    }
  }
};
</script>
